import { render, staticRenderFns } from "./PermissionCard.vue?vue&type=template&id=6ef8b06b&scoped=true"
import script from "./PermissionCard.vue?vue&type=script&lang=js"
export * from "./PermissionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef8b06b",
  null
  
)

export default component.exports